export default function equalValue(value1, value2) {
  if (value2 === undefined) return true;
  if (typeof value1 === 'object' && typeof value2 === 'object') {
    return JSON.stringify(value2) === JSON.stringify(value1);
  } else {
    return value2 === value1;
  }
}
